import { Box } from '@mui/material';
import { updateUser } from 'APIs/AuthApi';
import { getOtherUserData } from 'APIs/UserDataApi';
import Loader from 'components/atoms/loader';
import Footer from 'components/organisms/Footer/MobileGlobalFooter';
import ProfileHeader from 'components/organisms/Header/MobileProfileHeader';
import { UserPlatform, UserProfileData } from 'interfaces/UserData.interface';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { uploadFileUtil } from 'utils/Fileupload.utils';
import Body from './ProfilePageBody';

type ContentType = {
  gallery: boolean;
  collector: boolean;
  backstage: boolean;
  badge: boolean;
  feeds: boolean;
  test?: string;
  collected? : boolean
};

const Profile = () => {
  const [contentPage, setContentPage] = React.useState<ContentType>({
    gallery: true,
    collector: false,
    backstage: false,
    badge: false,
    feeds: false,
    collected : false
    
  });

  function isGallery(): void {
    setContentPage({
      gallery: true,
      collector: false,
      backstage: false,
      badge: false,
      feeds: false,
      collected : false
    });
  }
  function isCollector(): void {
    setContentPage({
      gallery: false,
      collector: true,
      backstage: false,
      badge: false,
      feeds: false,
      collected : false
    });
  }
  function isBackstage(): void {
    setContentPage({
      gallery: false,
      collector: false,
      backstage: true,
      badge: false,
      feeds: false,
      collected : false
    });
  }
  const isBadge = (): void => {
    setContentPage({
      gallery: false,
      collector: false,
      backstage: false,
      badge: true,
      feeds: false,
      collected : false
    });
  };

  const isFeed = (): void => {
    setContentPage({
      gallery: false,
      collector: false,
      backstage: false,
      badge: false,
      feeds: true,
      collected : false
    });
  };
  const isCollected = (): void => {
    setContentPage({
      gallery: false,
      collector: false,
      backstage: false,
      badge: false,
      feeds: false,
      collected : true
    });
  };

  const { username } = useParams();
  // const [currentTab, setCurrentTab] = React.useState<string>("Feed");
  const [editing] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<UserProfileData>({
    name: '',
    username: '',
    email: '',
    address: '',
    walletAddress: '',
    instagram: '',
    twitter: '',
    avatar: '',
    banner: '',
    verified: false,
    website: '',
    facebook: '',
    tiktok: '',
    platform: UserPlatform.CLIENT,
    seenOnBoarding: false,
    canPost: false,
    backstageDesc: '',
    followers: [],
    following: [],
  });

  // const handleEditing = () => {
  //   setEditing(!editing);
  // }

  const handleSubmit = async () => {
    let avatarUrl = data.avatar;
    let bannerUrl = data.banner;
    if (data.avatar) {
      try {
        let file = await fetch(data.avatar)
          .then(r => r.blob())
          .then(
            blobFile =>
              new File([blobFile], `${username}_avatar_${Date.now()}.png`, {
                type: 'image/png',
              })
          );
        const url = await uploadFileUtil(file);
        avatarUrl = url;
      } catch (error) {
        // console.error(error)
      }
    }

    if (data.banner) {
      try {
        let file = await fetch(data.banner)
          .then(r => r.blob())
          .then(
            blobFile =>
              new File([blobFile], `${username}_banner_${Date.now()}.png`, {
                type: 'image/png',
              })
          );
        const url = await uploadFileUtil(file);
        bannerUrl = url;
      } catch (error) {
        // console.error(error)
      }
    }
    await updateUser({ ...data, avatar: avatarUrl, banner: bannerUrl });
  };

  React.useEffect(() => {
    if (editing === false) {
      handleSubmit();
    }
    // eslint-disable-next-line
  }, [editing]);

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (!username) return;
      const userData = await getOtherUserData(username);
      if (userData) {
        const userData = (await getOtherUserData(username)) as UserProfileData;
        setData(data => ({ ...data, ...userData }));
      }
      setLoading(false);
    };

    fetchData();
  }, [username]);




  return (
    <React.Fragment>
      <Box>
        {loading ? (
          <Loader size="2" sx={{ height: '100%', marginTop: '45vh' }} />
        ) : (
          <>
            {' '}
            <ProfileHeader
              Gallery={isGallery}
              Collector={isCollector}
              Backstage={isBackstage}
              Badge={isBadge}
              Feed={isFeed}
              Collected={isCollected}
              data={data}
            />
            <Body page={contentPage}  Feed={isFeed} data={data} />{' '}
          </>
        )}
        <Footer />
      </Box>
    </React.Fragment>
  );
};

export default Profile;
